module.exports = __webpack_public_path__ + "img/c06_unitstartechbodkinarrow_Normal_ua.7e135208.webp";